export default {
    mutations: {
        SET_LOADING: 'setLoading',
        SET_HAS_ERROR: 'setHasError',
        SET_ERROR_MESSAGE: 'setErrorMessage',
        SET_ERROR: 'setError',
        RESET_BASE_STATE: 'resetBaseState',
    },
};
